import { StatusTone } from '../../../components/StatusBadge'

/**
 * J&J durum rozetinin rengi. Durum hem J&J'nin İngilizcesiyle (Paid, Rejected, Aging to terms ...) hem
 * Türkçe karşılığıyla (Ödendi, Reddedildi ...; JnjApText.TranslateStatus) gelebilir; ikisi de tanınır.
 * Ödendi yeşil, reddedildi / uyuşmazlık kırmızı, bekleyen her şey sarı; bilinmeyen gri.
 */
export const jnjStatusTone = (status: string | undefined | null): StatusTone => {
    const s = (status ?? '').trim().toLocaleLowerCase('tr-TR')

    if (!s)
        return 'light'

    if (s.startsWith('paid') || s.includes('cleared') || s.startsWith('ödendi'))
        return 'success'

    // Mismatch: faturadaki tutar / fiyat PO ile uyuşmuyor (TEST'teki gerçek veride görüldü).
    if (s.includes('reject') || s.includes('cancel') || s.includes('block') || s.includes('discrepanc') || s.includes('mismatch')
        || s.includes('reddedildi') || s.includes('uyuşmazlık') || s.includes('iptal') || s.includes('bloke'))
        return 'danger'

    if (s.includes('aging') || s.includes('pending') || s.includes('approval') || s.includes('process') || s.includes('due') || s.includes('hold')
        || s.includes('ödemeye hazır') || s.includes('inceleniyor') || s.includes('bekliyor') || s.includes('bekleniyor'))
        return 'warning'

    return 'light'
}

/** Rozetin ipucu metni: kısa Türkçe anlam. */
export const jnjStatusHint = (status: string | undefined | null): string => {
    switch (jnjStatusTone(status)) {
        case 'success': return 'Ödendi'
        case 'danger': return 'Reddedildi / sorunlu'
        case 'warning': return 'Bekliyor'
        default: return ''
    }
}
